module.exports = require("@esri/arcgis-rest-request");